var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_",
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M95.506,152.511c0,31.426,25.567,56.991,56.994,56.991c31.425,0,56.99-25.566,56.99-56.991 c0-31.426-25.565-56.993-56.99-56.993C121.073,95.518,95.506,121.085,95.506,152.511z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M283.733,77.281c0.444-0.781,0.436-1.74-0.023-2.513c-13.275-22.358-32.167-41.086-54.633-54.159 C205.922,7.134,179.441,0.012,152.5,0.012c-46.625,0-90.077,20.924-119.215,57.407c-0.643,0.804-0.727,1.919-0.212,2.81 l42.93,74.355c0.45,0.78,1.28,1.25,2.164,1.25c0.112,0,0.226-0.008,0.339-0.023c1.006-0.137,1.829-0.869,2.083-1.852 c8.465-32.799,38.036-55.706,71.911-55.706c2.102,0,4.273,0.096,6.455,0.282c0.071,0.007,0.143,0.01,0.214,0.01H281.56 C282.459,78.545,283.289,78.063,283.733,77.281z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    d: "M175.035,224.936c-0.621-0.803-1.663-1.148-2.646-0.876c-6.457,1.798-13.148,2.709-19.889,2.709 c-28.641,0-55.038-16.798-67.251-42.794c-0.03-0.064-0.063-0.126-0.098-0.188L23.911,77.719c-0.446-0.775-1.272-1.25-2.165-1.25 c-0.004,0-0.009,0-0.013,0c-0.898,0.005-1.725,0.49-2.165,1.272C6.767,100.456,0,126.311,0,152.511 c0,36.755,13.26,72.258,37.337,99.969c23.838,27.435,56.656,45.49,92.411,50.84c0.124,0.019,0.248,0.027,0.371,0.027 c0.883,0,1.713-0.47,2.164-1.25l42.941-74.378C175.732,226.839,175.657,225.739,175.035,224.936z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M292.175,95.226h-85.974c-1.016,0-1.931,0.615-2.314,1.555c-0.384,0.94-0.161,2.02,0.564,2.73 c14.385,14.102,22.307,32.924,22.307,53c0,15.198-4.586,29.824-13.263,42.298c-0.04,0.058-0.077,0.117-0.112,0.178l-61.346,106.252 c-0.449,0.778-0.446,1.737,0.007,2.513c0.449,0.767,1.271,1.237,2.158,1.237c0.009,0,0.019,0,0.028,0 c40.37-0.45,78.253-16.511,106.669-45.222C289.338,231.032,305,192.941,305,152.511c0-19.217-3.532-37.956-10.498-55.698 C294.126,95.855,293.203,95.226,292.175,95.226z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.605791, 0, 0, 1.58325, 5.879488, 6.861857)",
    style: {}
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.9cf70c10ad87b7b05839a93e3b370d57.svg";
export { ForwardRef as ReactComponent };